import type { HttpClient } from '@shared/http/http-client';
import type {
  IDesignRequestRepository,
  DesignRequestListQuery,
} from '@domain/data-contracts/design-request-repository.interface';
import type { DesignRequest } from '@domain/models/design-request.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapDesignRequestDto,
  mapPaged,
  type DesignRequestDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/design-requests';

export class DesignRequestRepository implements IDesignRequestRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: DesignRequestListQuery): Promise<PagedResult<DesignRequest>> {
    const response = await this.http.get<PagedDto<DesignRequestDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapDesignRequestDto);
  }
}

function pruneParams(query: DesignRequestListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.status) { out.status = query.status; }
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
